import React from 'react';
import moment from 'moment-timezone';
import tickIcon from '../../../assets/img/icons/tick-white-bold.svg';

import {
  VisitDateBox,
  CheckIconContainer,
  CheckIcon,
  VisitDateContent,
  VisitDateInfo,
  VisitDate,
  VisitTime,
  VisitStatus,
} from '../invoiceStyles';
import { useState } from 'react';

const VisitDateComponent = ({ job, visitDateSelect, index }) => {
  const timezone = localStorage.getItem('selected_organization_timezone') || moment.tz.guess();
  const [isSelected, setIsSelected] = useState(null);

  const handleClick = () => {
    setIsSelected(!isSelected);
    visitDateSelect(job, index);
  };

  const localizeTime = time => {
    if (!time || !timezone) return null;
    try {
      return moment(time + 'Z')
        .tz(timezone)
        .toDate();
    } catch (e) {
      return null;
    }
  };

  // Format date: "25 Jan 2026"
  const formattedDate = job?.start_time
    ? moment(localizeTime(job.start_time)).format('DD MMM YYYY')
    : 'N/A';

  // Format time: "10:30 am - 2:30 pm"
  const formattedTime = () => {
    if (job?.start_time && job?.end_time) {
      const startMoment = localizeTime(job.start_time);
      const endMoment = localizeTime(job.end_time);
      
      if (startMoment && endMoment) {
        const startTime = moment(startMoment).format('h:mm a');
        const endTime = moment(endMoment).format('h:mm a');
        return `${startTime} - ${endTime}`;
      }
    }
    return 'N/A';
  };

  // Determine status
  const getStatus = () => {
    if (!job?.start_time) return { text: 'N/A', type: 'upcoming' };
    
    const today = moment().tz(timezone).format('YYYY-MM-DD');
    const jobDateMoment = localizeTime(job.start_time);
    
    if (!jobDateMoment) return { text: 'N/A', type: 'upcoming' };
    
    const jobDate = moment(jobDateMoment).format('YYYY-MM-DD');

    if (job.status === 'completed' || jobDate < today) {
      return { text: 'Completed', type: 'completed' };
    } else if (jobDate === today) {
      return { text: 'Today', type: 'upcoming' };
    } else {
      return { text: 'Upcoming', type: 'upcoming' };
    }
  };

  const status = getStatus();

  return (
    <VisitDateBox isSelected={isSelected}>
      <CheckIconContainer isSelected={isSelected} onClick={handleClick}>
        <CheckIcon isSelected={isSelected}>
          {isSelected && <img src={tickIcon} alt="selected" />}
        </CheckIcon>
      </CheckIconContainer>
      <VisitDateContent>
        <VisitDateInfo>
          <VisitDate>{formattedDate}</VisitDate>
          <VisitTime>{formattedTime()}</VisitTime>
        </VisitDateInfo>
        <VisitStatus isSelected={isSelected} status={status.type}>
          {status.text}
        </VisitStatus>
      </VisitDateContent>
    </VisitDateBox>
  );
};

export default VisitDateComponent;
